import { defineStore } from "pinia";
import axiosInstance from "@/plugins/axios.js";
import {login, register, checkAuth, logout, updateEmail, updatePassword} from "@/services/loginApi.js";
import snackbarService from "@/services/snackbarService";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: { email: null, verified: null, roles: [] },
    isAuthenticated: false,
    error: null,
  }),

  persist: true,

  actions: {
    async login(email, password) {
        this.error = null;

        try {
          console.log("THIS IS A TEST")
          var response = await login(email,password);

          this.user.email = response.data.email;
          this.user.verified = response.data.verified;
          this.user.roles = response.data.roles; 

          this.isAuthenticated = true;

          return true;
        }
        catch(error){
          this.error =
          error.response?.data?.message || "Une erreur est survenue.";
          return false;
        }
    },

    async register(email, password, consent) {
      this.error = null;

        try {
          var response = await register(email, password, consent);

          this.user.email = response.data.email;
          this.user.verified = response.data.verified;
          this.user.roles = response.data.roles; 

          this.isAuthenticated = true;

          return true;
        }
        catch(error){
          this.error =
          error.response?.data?.message || "Une erreur est survenue.";
          return false;
        }
    },

    async checkAuth() {
      var response = await checkAuth();
      this.isAuthenticated = response;
      return response;
    },

    async logout() {
      try {
        await logout();
      } catch (error) {
        snackbarService.showSnackbar("Logout failed...", "red");
      } finally {
        this.user = { email: null, verified: null, roles: [] };
        this.isAuthenticated = false;
        this.$reset();
      }
    },

    async updateEmail(newEmail) {

      this.error = null;

        try {
          var response = await updateEmail(newEmail);

          this.user.email = newEmail;
          this.isAuthenticated = response;

          return true;
        }
        catch(error){
          this.error =
          error.response?.data?.message || "Une erreur est survenue.";
          return false;
        }
    },

    async updatePassword(email, oldPassword, newPassword) {
      try {
        await updatePassword(email, oldPassword, newPassword);
        return true;
      } catch (error) {
        this.error =
          error.response?.data?.message || "Une erreur est survenue.";
        return false;
      }
    },

    async deleteAccount() {
      try {
        await axiosInstance.delete("/UserStock");
      } catch (error) {
        throw error;
      }
    },
  },
});
